import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BrowserMultiFormatReader, IScannerControls } from '@zxing/browser';
import { BarcodeFormat, DecodeHintType } from '@zxing/library';
import { AlertService } from 'src/app/services/base/alert.service';

@Component({
  selector: 'app-barcode-scan-overlay',
  templateUrl: './barcode-scan-overlay.component.html',
  styleUrls: ['./barcode-scan-overlay.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarcodeScanOverlayComponent implements OnInit, OnDestroy {
  @ViewChild('video', { static: true }) videoEl!: ElementRef<HTMLVideoElement>;

  private stream: MediaStream | null = null;
  private controls: IScannerControls | null = null;

  constructor(
    private modalCtrl: ModalController,
    private alert: AlertService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit() {
    await this.startScan();
  }

  ngOnDestroy() {
    this.stopStream();
  }

  private async startScan() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });
      this.videoEl.nativeElement.srcObject = this.stream;

      const hints = new Map<DecodeHintType, unknown>();
      hints.set(DecodeHintType.POSSIBLE_FORMATS, [
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8,
        BarcodeFormat.CODE_128,
        BarcodeFormat.CODE_39,
        BarcodeFormat.QR_CODE,
      ]);

      const reader = new BrowserMultiFormatReader(hints);
      this.controls = await reader.decodeFromVideoElement(
        this.videoEl.nativeElement,
        (result) => {
          if (result) {
            this.stopStream();
            this.modalCtrl.dismiss({ value: result.getText() });
          }
        },
      );
    } catch {
      await this.alert.presentToast('Kamera konnte nicht geöffnet werden');
      this.modalCtrl.dismiss();
    }
  }

  private stopStream() {
    this.controls?.stop();
    this.controls = null;
    this.stream?.getTracks().forEach(t => t.stop());
    this.stream = null;
  }

  close() {
    this.stopStream();
    this.modalCtrl.dismiss();
  }
}
